import styles from "./Slider.module.scss";

type SliderProps = {
  staticValue: number;
  dynamicValue?: number;
  onChange?: (value: number) => void;
  legendLeft?: string;
  legendRight?: string;
  title: string;
  dataTestId?: string;
  className: string;
};

const Slider = ({
  staticValue,
  dynamicValue,
  onChange,
  legendLeft,
  legendRight,
  title,
  className,
  dataTestId
}: SliderProps) => {
  return (
    <div
      className={styles.rating}
      style={{ backgroundPositionX: `${staticValue * 100}%` }}
    >
      <div className={styles.subHeader}>{title}</div>
      <div className={styles.rangeContainer}>
        <input
          data-testid={dataTestId}
          className={`${className} ${styles.slider}`}
          type="range"
          min="0"
          max="1"
          step="0.001"
          defaultValue={dynamicValue !== undefined ? dynamicValue : staticValue}
          onChange={(event) =>
            onChange?.(parseFloat(event.currentTarget.value))
          }
          disabled={dynamicValue === undefined}
        />
        <input
          className={styles.sliderStaticValue}
          type="range"
          min="0"
          max="1"
          step="0.001"
          defaultValue={staticValue}
          disabled
          data-testid="slider-static-value"
        />
      </div>
      <div className={styles.legends}>
        <span className={`${styles.text} ${styles.left}`}>
          {legendLeft ?? ""}
        </span>
        <span className={`${styles.text} ${styles.right}`}>
          {legendRight ?? ""}
        </span>
      </div>
    </div>
  );
};

export default Slider;
